
import angular from 'angular';


const controllerInfo = {
    module: 'ib-seat-map-module',
    inject: ['$uibModalInstance', 'modalMessage', '$sce'],
    required: []
};



export class SeatMapModalController implements ng.IController {

    constructor (
        private $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
        private modalMessage: any,
        private $sce: any) {

    }

    close = (): void => {
        this.$uibModalInstance.dismiss('cancel');
    };

    accept = (): void => {
        this.$uibModalInstance.close();
    };

}


try {
    SeatMapModalController.$inject = controllerInfo.inject;
    angular.module(controllerInfo.module).controller(SeatMapModalController.name, SeatMapModalController);

} catch (error) {
    const mod = angular.module(controllerInfo.module, controllerInfo.required);
    SeatMapModalController.$inject = controllerInfo.inject;
    mod.controller(SeatMapModalController.name, SeatMapModalController);
}